import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Replace } from '../../stores/cashRegisters/actions';

// Service
import CashRegisterService from '../../services/cashRegisterService';

//Hooks
import useUser from "../user/useUser";

const initFilters = {
    branchId: 0,
    active: true,
    pageNumber: 1,
    pageSize: 100
}

const useCashRegisters = ( defaultFilters ) => {
    const { branch } = useUser();

    const [filters, setFilters] = useState({ 
        ...initFilters, 
        ...defaultFilters 
    })

    const { cashRegisters } = useSelector(state => state.cashRegisters_data);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if(branch?.id)
            setFilters(state => ({ ...state, branchId: branch.id }))
    }, [branch?.id])

    useEffect(() => {
        const SearchCashRegisters = async () => {
            setLoading(true);
            await CashRegisterService
                .SearchCashRegisters(filters)
                .then(res => dispatch(Replace(res.values, res.totalResults, res.totalPage)))
                .finally(() => setLoading(false));
        }

        if (filters?.branchId && filters?.branchId > 0)
            SearchCashRegisters();
    }, [dispatch, filters])

    return {
        cashRegisters,
        loading,
        filters,
        setFilters
    }
}

export default useCashRegisters;